// extracted by mini-css-extract-plugin
export default {"buttonScroll":"ScrollButton_buttonScroll__vt1Pt"};